import React from 'react';
import Button from './Button';
import { Dumbbell, Utensils, CheckCircle } from 'lucide-react';

const Products = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-semibold text-white mb-6 text-glow">
            PRODUCTS & SERVICES
          </h2>
          <div className="w-16 h-1 bg-red-600 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Product Card 1 */}
          <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-8 transition-transform duration-300 hover:scale-105">
            <div className="text-red-600 mb-6">
              <Utensils size={48} />
            </div>
            {/* Recipe Book image */}
            <div className="mb-6">
              <img src="/recipebook.png" alt="Recipe Book" className="w-full h-52 md:h-60 object-cover rounded-md shadow-md" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-white">Recipe Book</h3>
            <p className="text-gray-300 mb-6">
              A comprehensive collection of delicious and nutritious recipes designed to support your fitness goals. Each recipe includes detailed macros and preparation instructions.
            </p>
            <Button variant="secondary" href="https://whop.com/eliteshapepersonaltraining/high-protein-recipe-book/" target="_blank" rel="noopener noreferrer">LEARN MORE</Button>
          </div>

          {/* Product Card 2 */}
          <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-8 transition-transform duration-300 hover:scale-105">
            <div className="text-red-600 mb-6">
              <CheckCircle size={48} />
            </div>
            {/* Picky Eaters image */}
            <div className="mb-6">
              <img src="/calorieshake.png" alt="Calories Shake for Picky Eaters" className="w-full h-52 md:h-60 object-cover rounded-md shadow-md" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-white">Picky Eaters Guide</h3>
            <p className="text-gray-300 mb-6">
              Struggling with limited food choices? This guide provides strategies and alternatives for picky eaters to maintain a healthy diet while staying within their comfort zone.
            </p>
            <Button variant="secondary" href="https://whop.com/eliteshapepersonaltraining/flavorful-gains/" target="_blank" rel="noopener noreferrer">LEARN MORE</Button>
          </div>

          {/* Product Card 3 */}
          <div className="bg-gray-900/50 backdrop-blur-sm rounded-lg p-8 transition-transform duration-300 hover:scale-105">
            <div className="text-red-600 mb-6">
              <Dumbbell size={48} />
            </div>
            {/* 8-Week Weight Loss image */}
            <div className="mb-6">
              <img src="/weightloss.png" alt="8-Week Weight Loss Program" className="w-full h-52 md:h-60 object-cover rounded-md shadow-md" />
            </div>
            <h3 className="text-2xl font-semibold mb-4 text-white">8-Week Home Weight Loss Program</h3>
            <p className="text-gray-300 mb-6">
              Lose 8-12 pounds in 8 weeks with our structured home workout and nutrition program. Perfect for busy individuals who want to transform their body from the comfort of their home.
            </p>
            <Button variant="secondary" href="https://whop.com/eliteshapepersonaltraining/lose-8-12-pounds-in-8-weeks/" target="_blank" rel="noopener noreferrer">LEARN MORE</Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;